export default __webpack_public_path__ + "static/media/dashboard.975cb76b.svg";